import React from 'react';
import axios from 'axios';
import Agentes from './Agentes';
import Ruta from './Ruta';
import Padron from './Padron';
import Modal from './Modal';
const google = window.google;

let googleMapa;
let marcadores = [];

const consultaGet = function(url, config) {
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + url, config)
    .then((resul) => {
      if (resul.data.status === "ok"){
        resolve(resul.data);
      } else {
        reject(resul.data.error);
      }
    })
    .catch((error) => {
      reject(error)
    });
  });
}

const consultaPost = function(url, datos, config) {
  return new Promise(function(resolve, reject) {
    axios.post(localStorage.getItem('apiUrl') + url, datos, config)
    .then((resul) => {
      if (resul.data.status === "ok"){
        resolve(resul.data);
      } else {
        reject(resul.data.error);
      }
    })
    .catch((error) => {
      reject(error)
    });
  });
}

const getUsuarios = function(){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/users/admin/listar';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    consultaGet(url, config)
    .then((data) => resolve(data.usuarios))
    .catch((error) => reject(error))
  });
}

const postEliminar = function(datos){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/rutas/admin/eliminar';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    consultaPost(url, datos, config)
    .then(() => resolve())
    .catch((error) => reject(error))
  });
}

const getPadron = function(){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/padron/admin/listar';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    consultaGet(url, config)
    .then((data) => resolve(data.padron.sort((a, b) => a.localidad_id > b.localidad_id)))
    .catch((error) => reject(error))
  });
}

const getRuta = function(id){
  return new Promise(function(resolve, reject) {
    const url = '/api/geo/rutas/admin/buscar';
    const config = {
      headers:{authorization:sessionStorage.getItem('token')},
      params:{usuario_id:id}
    };
    consultaGet(url, config)
    .then((data) => resolve(data.ruta))
    .catch((error) => reject(error))
  });
}

export default class Gestion extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      usuarios:[],
      padron:[],
      ruta:[],
      usuario_id:null,
      zoomPrevio:8,
      tipoMarcadores:true
    }
    this.googleMapa = React.createRef();
  }

  componentDidMount(){
    getUsuarios()
    .then((usuarios) => {
      getPadron()
      .then((padron) => {
        this.setState({loading:false, usuarios, padron})
        this.abrirMapa()
      })
    })
    .catch((error) => console.log(error))
  }

  componentWillUnmount(){
    marcadores = []
  }

  abrirMapa(){
    googleMapa = new google.maps.Map(document.getElementById('mapa'), {
      center: { lat:-54.806518330177056, lng:-68.30626216769735 },
      zoom: 12,
    })
    setTimeout(() => {
      this.cargarMarcadores(this.state.padron);
    },  1500)
  }

  clickMarcadorEvento(index, item, soloUbicacion = false){
    marcadores[index].informacion.open(googleMapa, marcadores[index].marcador);
    this.seleccionarPersona(item,soloUbicacion)
  }

  async cargarMarcadores(padron, ruta = false){
    padron.forEach((item, i) => {
      if (!ruta){
        if (!item.error){
          const ubicacion = {
            lat:parseFloat(item.latitud),
            lng:parseFloat(item.longitud)
          }
          const contentString =
            '<div id="content" style="color:black">' +
              '<div id="siteNotice">' +
              "</div>" +
              '<h1 id="firstHeading" class="firstHeading">' + item.documento +  " - " + item.apellidos + ", " + item.nombres + '</h1>' +
              '<div id="bodyContent">' +
                '<h2>Dirección: ' + item.calle + ' ' +  item.numero + '</h2>' +
                '<h3>Estado: ' + item.estado + '</h3>' +
              '</div>' +
            '</div>';
          const cantidad = marcadores.push({
            informacion:new google.maps.InfoWindow({
              content: contentString,
            }),
            marcador:new google.maps.Marker({
              opacity:item.estado === "SIN ASIGNAR" ? 1 : 0.3,
              position: ubicacion,
              map: googleMapa,
              optimized:true
            })
          });
          if (item.estado === "SIN ASIGNAR"){
            marcadores[cantidad-1].marcador.addListener('click',(e) => this.clickMarcadorEvento(cantidad-1, item))
          } else {
            marcadores[cantidad-1].marcador.addListener('click',(e) => this.clickMarcadorEvento(cantidad-1, item, true))
          }
        }
      } else {
        if (!item.persona.error){
          const ubicacion = {
            lat:parseFloat(item.persona.latitud),
            lng:parseFloat(item.persona.longitud)
          }
          const contentString =
            '<div id="content" style="color:black">' +
              '<div id="siteNotice">' +
              "</div>" +
              '<h1 id="firstHeading" class="firstHeading">' + item.documento +  " - " + item.apellidos + ", " + item.nombres + '</h1>' +
              '<div id="bodyContent">' +
                '<h2>Dirección: ' + item.calle + ' ' +  item.numero + '</h2>' +
                '<h3>Estado: ' + item.estado + '</h3>' +
              '</div>' +
            '</div>';
          const cantidad = marcadores.push({
            informacion:new google.maps.InfoWindow({
              content: contentString,
            }),
            marcador:new google.maps.Marker({
              opacity:1,
              position: ubicacion,
              map: googleMapa,
              optimized:true
            })
          });
          marcadores[cantidad-1].marcador.addListener('click',(e) => this.clickMarcadorEvento(cantidad-1, item, true))
        }
      }
    });
  }

  seleccionarUsuario(id){
    this.setState({usuario_id:id})
    getRuta(id)
    .then((ruta) => {
      this.setState({ruta})
    })
    .catch((error) => console.log(error))
  }

  seleccionarPersona(persona, soloUbicacion = false){
    const ubicacion = {
      lat: parseFloat(persona.latitud),
      lng: parseFloat(persona.longitud)
    };
    googleMapa.setCenter(ubicacion);
    googleMapa.setZoom(17);
    if (!soloUbicacion){
      setTimeout(() => {
        if (this.state.usuario_id === null){
          alert("Seleccione un agente")
        } else {
          if (this.state.ruta.findIndex((item) => item.persona.id === persona.id) !== -1){
            alert("Persona ya asignada")
          } else {
            if (window.confirm('¿Desea asignar persona a usuario?')){
              const url = localStorage.getItem('apiUrl') + '/api/geo/rutas/admin/agregar';
              const config = {headers:{authorization:sessionStorage.getItem('token')}};
              const datos = {
                usuario_id:this.state.usuario_id,
                persona_id:persona.id
              }
              axios.post(url, datos, config)
              .then((resul) => {
                if (resul.data.status === "ok"){
                  getRuta(this.state.usuario_id)
                  .then((ruta) =>{
                    getPadron()
                    .then((padron) =>{
                      this.setState({ruta, padron});
                      this.limpiarMarcadores()
                      .then(() => {
                        this.cargarMarcadores(padron);
                      })
                    })
                  })
                  .catch((error) => {
                    console.log(error)
                  })
                } else {
                  console.log(resul.data.error)
                  alert("Ocurrio un error")
                }
              })
              .catch((error) => {
                console.log(error)
                alert("Ocurrio un error")
              })
            }
          }
        }
      }, 2000)
    }
  }

  limpiarMarcadores(){
    return new Promise(function(resolve, reject) {
      marcadores.forEach((item, i) => {
        if (item.marcador !== undefined)
          item.marcador.setMap(null);
      });
      marcadores = []
      resolve()
    });
  }

  cambioTipoMarcadores(valor){
    if (this.state.usuario_id === null){
      alert("Seleccione un agente");
    } else {
      this.limpiarMarcadores()
      .then(() => {
        if (valor){
          this.cargarMarcadores(this.state.padron)
        } else {
          this.cargarMarcadores(this.state.ruta, true)
        }
        this.setState({tipoMarcadores:valor})
      });
    }
  }

  eliminarAsignacion(asignacion_id){
    postEliminar({asignacion_id})
    .then(() => {
      getRuta(this.state.usuario_id)
      .then((ruta) =>{
        getPadron()
        .then((padron) =>{
          this.setState({ruta, padron});
          this.limpiarMarcadores()
          .then(() => {
            this.cargarMarcadores(padron);
          })
        })
      })
      .catch((error) => {
        console.log(error)
      })
    })
  }

  render(){
    const {usuarios, padron, ruta, usuario_id, tipoMarcadores} = this.state;
    return(
      <div className="Todo Index">
        <h2>Gestión de rutas</h2>
        <div style={{width:'100%', display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
          <div style={{flex:1, width:'100%', display:'flex', flexDirection:'column', alignItems:'center', minWidth:200}}>
            <h4 style={{margin:10, padding:0}}>Agentes</h4>
            <Agentes
              usuarios={usuarios}
              seleccionar={(id) => this.seleccionarUsuario(id)}
            />
          </div>
          <div style={{flex:1, width:'100%', display:'flex', flexDirection:'column', alignItems:'center', minWidth:200}}>
            <h4 style={{margin:10, padding:0}}>Ruta del agente</h4>
            <Ruta
              ruta={ruta}
              seleccionarPersona={(persona) => this.seleccionarPersona(persona, true)}
              eliminar={(asignacion_id) => this.eliminarAsignacion(asignacion_id)}
            />
          </div>
          <div style={{flex:2, display:'flex', flexDirection:'column', alignItems:'center', minWidth:200}}>
            <h4 style={{margin:10}}>Ubicaciones</h4>
            <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
              <span style={{padding:'0px 10px 10px 10px'}}>RUTA</span>
              <label class="switch" style={{marginBottom:10}}>
                <input
                  type="checkbox"
                  checked={tipoMarcadores}
                  onChange={(e) => this.cambioTipoMarcadores(e.target.checked)}
                />
                <span class="slider round"></span>
              </label>
              <span style={{padding:'0px 10px 10px 10px'}}>TODOS</span>
            </div>
            <div id="mapa" style={{width:'100%',height: 556, borderRadius:10, overflow:'hidden'}} ref={this.googleMapa}></div>
          </div>
          <div style={{flex:1, display:'flex', flexDirection:'column', alignItems:'center', minWidth:200}}>
            <h4 style={{margin:10, padding:0}}>Listado Padrón</h4>
            <Padron
              padron={padron}
              habilitado={usuario_id !== null}
              seleccionar={(persona) => this.seleccionarPersona(persona)}
            />
          </div>
        </div>
      </div>
    );
  }
}
